import gql from 'graphql-tag';

/**
 * Data of the block project-presentations: the project's attachments and build states of the
 * block's attachment types (Kurzteaser, Masterpräsentation, Objektfoto). Read through
 * `Project.blocks.presentations`, which checks the block's read permission.
 */
export const PROJECT_PRESENTATIONS_FIELDS = gql`
  fragment projectPresentationsFields on ProjectPresentationsBlock {
    id
    number
    attachments {
      id
      path
      filename
      displayFilename
      size
      mimetype
      attachmentType
      createdAt
    }
    attachmentBuildStates {
      attachmentType
      state
    }
  }
`;
